// src/admin/pages/AdminSettings.js
import React, { useState, useContext, useEffect } from "react";
import AdminSidebar from "../AdminSidebar";
import AdminHeader from "../AdminHeader";
import {
    FaSave,
    FaUpload,
    FaStore,
    FaTruck,
    FaPhone,
    FaEnvelope,
} from "react-icons/fa";
import { AdminLanguageContext } from "../context/AdminLanguageContext";
import {
  getAdminCategoryCards,
  updateAdminCategoryCard,
  getAdminLuxuryVideos,
  updateAdminLuxuryVideo,
  createAdminLuxuryVideo,
  getAdminCategoryHero,
  updateAdminCategoryHero,
  getAdminFeaturedCategories,
  updateAdminFeaturedCategory,
  getAdminCategoryCarousel,
  updateAdminCategoryCarouselImage,
  updateAdminCategoryCarouselOrder,
  getAdminPopularSearchOrder,
  updateAdminPopularSearchOrder,
  getAdminAccessoriesSection,          
  updateAdminAccessoriesSection,
  getAdminFlatsMiniSection,
  updateAdminFlatsMiniSection,
} from "../../services/adminHomepage.api";
import { getAdminCategoriesWithProducts } from "../../services/adminProducts.api";
import { getAdminProducts  } from "../../services/adminProducts.api";
import { mapBackendProduct } from "../../utils/mapProduct";
import { FaTrash } from "react-icons/fa";
import { deleteAdminLuxuryVideo } from "../../services/adminHomepage.api";
import { uploadAdminLuxuryVideo } from "../../services/adminHomepage.api";
import { uploadAdminFile } from "../../services/adminUpload.api";
import { uploadAdminImage } from "../../services/adminHomepage.api";

function AdminSettings() {
    const [isOpen, setIsOpen] = useState(false);
    const { lang } = useContext(AdminLanguageContext);
    
    const [categoryCards, setCategoryCards] = useState([]);
    const [luxuryVideos, setLuxuryVideos] = useState([]);
    const [categoryHero, setCategoryHero] = useState(null);
    const [featuredCategories, setFeaturedCategories] = useState([]);
    
    const [accessoriesSection, setAccessoriesSection] = useState(null);

    const [editing, setEditing] = useState(null);
    
    const [editModal, setEditModal] = useState(null);
    const [categories, setCategories] = useState([]);
    
    const [carouselCategories, setCarouselCategories] = useState([]);
    
    const [dragIndex, setDragIndex] = useState(null);

    const [popularOrder, setPopularOrder] = useState([]);
    const [popularDragIndex, setPopularDragIndex] = useState(null);

    const [popularImages, setPopularImages] = useState({});
    const [flatsMiniSection, setFlatsMiniSection] = useState(null);
    
    const [videoFile, setVideoFile] = useState(null);
    
    const [confirm, setConfirm] = useState(null);
    const [toast, setToast] = useState("");
    const [uploading, setUploading] = useState(false);


    const showToast = (msg) => {
  setToast(msg);
  setTimeout(() => setToast(""), 2500);
};


const POPULAR_SPECIALS = [
  { key: "new-in", labelEN: "New In", labelAR: "وصل حديثاً" },
  { key: "sale", labelEN: "Sale", labelAR: "تخفيضات" },
  { key: "bestsellers", labelEN: "Bestsellers", labelAR: "الأكثر مبيعاً" },
];

const popularItems = [
  ...categories.map((c) => ({
    key: c.slug,
    labelEN: c.name_en,
    labelAR: c.name_ar,
  })),
  ...POPULAR_SPECIALS,
];

const ASSET_BASE =
  process.env.REACT_APP_ASSET_BASE || "";

const resolveImage = (url) => {
  if (!url) return "";

  // blob preview
  if (url.startsWith("blob:")) return url;

  // already absolute
  if (url.startsWith("http")) return url;

  // ✅ always use backend asset server
  return `${ASSET_BASE}${url}`;
};





// apply saved order (anything missing goes to the end)
const orderedPopularItems = (() => {
  if (!popularOrder?.length) return popularItems;

  const map = new Map(popularItems.map((x) => [x.key, x]));
  const ordered = [];

  popularOrder.forEach((k) => {
    if (map.has(k)) ordered.push(map.get(k));
  });

  // append leftovers not in saved order
  popularItems.forEach((x) => {
    if (!popularOrder.includes(x.key)) ordered.push(x);
  });

  return ordered;
})();


const handleDragStart = (index) => {
  setDragIndex(index);
};

const handleDrop = async (dropIndex) => {
  if (dragIndex === null || dragIndex === dropIndex) return;

  const updated = [...carouselCategories];
  const [moved] = updated.splice(dragIndex, 1);
  updated.splice(dropIndex, 0, moved);

  // reassign sort_order based on new index
  const reordered = updated.map((c, i) => ({
    ...c,
    sort_order: i + 1,
  }));

  setCarouselCategories(reordered);
  setDragIndex(null);

  // 🔥 persist order (sequential, safe)
  for (const c of reordered) {
    await updateAdminCategoryCarouselOrder(c.id, c.sort_order);
  }
};

    const TEXT = {
        EN: {
            title: "Store Settings",
            success: "Settings saved successfully!",
            logo: "Store Logo",
            storeName: "Store Name",
            email: "Contact Email",
            phone: "Contact Phone Number",
            delivery: "Delivery Fee ($)",
            save: "Save Settings",
        },
        AR: {
            title: "إعدادات المتجر",
            success: "تم حفظ الإعدادات بنجاح!",
            logo: "شعار المتجر",
            storeName: "اسم المتجر",
            email: "بريد التواصل",
            phone: "رقم هاتف التواصل",
            delivery: "رسوم التوصيل ($)",
            save: "حفظ الإعدادات",
        },
    }[lang];

    const [storeName, setStoreName] = useState("Kids Toys Store");
    const [email, setEmail] = useState("support@example.com");
    const [phone, setPhone] = useState("+123456789");
    const [deliveryFee, setDeliveryFee] = useState(5);
    const [logo, setLogo] = useState(null);

    const [success, setSuccess] = useState("");

    const handleLogoUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            setLogo(URL.createObjectURL(file)); // TEMP preview only
        }
    };

    const saveSettings = () => {
        setSuccess(TEXT.success);
        setTimeout(() => setSuccess(""), 1500);
    };

    const handlePopularDragStart = (index) => setPopularDragIndex(index);

const handlePopularDrop = async (dropIndex) => {
  if (popularDragIndex === null || popularDragIndex === dropIndex) return;

  const updated = [...orderedPopularItems];
  const [moved] = updated.splice(popularDragIndex, 1);
  updated.splice(dropIndex, 0, moved);

  const newOrderKeys = updated.map((x) => x.key);

  setPopularOrder(newOrderKeys);
  setPopularDragIndex(null);

  await updateAdminPopularSearchOrder(newOrderKeys);
};


    useEffect(() => {
  getAdminPopularSearchOrder()
    .then((order) => setPopularOrder(Array.isArray(order) ? order : []))
    .catch(() => {});
}, []);


    useEffect(() => {
  getAdminCategoriesWithProducts()
    .then(setCategories)
    .catch(() => {});
}, []);


    useEffect(() => {
  getAdminCategoryCards().then(setCategoryCards);
  getAdminLuxuryVideos().then(setLuxuryVideos);
}, []);

    useEffect(() => {
  getAdminCategoryHero().then(setCategoryHero).catch(() => {});
}, []);

useEffect(() => {
  getAdminFeaturedCategories().then(setFeaturedCategories);
}, []);

useEffect(() => {
  getAdminCategoryCarousel().then(setCarouselCategories).catch(() => {});
}, []);

useEffect(() => {
  getAdminAccessoriesSection().then(setAccessoriesSection);
}, []);

useEffect(() => {
  getAdminFlatsMiniSection()
    .then(setFlatsMiniSection)
    .catch(() => {});
}, []);


useEffect(() => {
  async function enrichImages() {
    const allProducts = await getAdminProducts();

    const updated = await Promise.all(
      carouselCategories.map(async (c) => {
        // keep admin override
        if (c.image_url) return c;

        try {
          const filtered = allProducts.filter((p) =>
            (p.categories || []).includes(c.slug)
          );

          const mapped = filtered
            .map(mapBackendProduct)
            .sort(
              (a, b) => new Date(b.created_at) - new Date(a.created_at)
            );

          return {
            ...c,
            image_url:
              mapped[0]?.images?.[0] || "/images/placeholder-product.jpg",
          };
        } catch {
          return c;
        }
      })
    );

    setCarouselCategories(updated);
  }

  if (carouselCategories.length) enrichImages();
}, []);


useEffect(() => {
  async function loadPopularImages() {
    const allProducts = await getAdminProducts();
    const map = {};

    categories.forEach((c) => {
      const filtered = allProducts.filter((p) =>
        (p.categories || []).includes(c.slug)
      );

      const mapped = filtered
        .map(mapBackendProduct)
        .sort(
          (a, b) => new Date(b.created_at) - new Date(a.created_at)
        );

      map[c.slug] =
        mapped[0]?.images?.[0] || "/images/placeholder-product.jpg";
    });

    setPopularImages(map);
  }

  if (categories.length) loadPopularImages();
}, [categories.length]);

const ImageUploadField = ({
  label,
  value,
  onChange,
  accept = "image/*",
}) => {
  return (
    <div className="mb-3">
      <label className="block text-sm font-medium text-gray-700 mb-1">
        {label}
      </label>

      <input
        type="file"
        accept={accept}
        className="hidden"
        id={`upload-${label}`}
        onChange={async (e) => {
          const file = e.target.files?.[0];
          if (!file) return;

          setUploading(true);
          try {
            const uploaded = await uploadAdminImage(file);
            onChange(uploaded.url);
          } catch (err) {
            alert(err.message || "Upload failed");
          } finally {
            setUploading(false);
          }
        }}
      />

      <label
        htmlFor={`upload-${label}`}
        className="
          inline-flex items-center gap-2
          px-4 py-2 mb-2
          rounded-xl
          border
          cursor-pointer
          bg-white
          hover:bg-gray-50
          text-sm font-semibold
        "
      >
        <FaUpload />
        {uploading ? "Uploading..." : "Upload"}
      </label>

      <input
        className="w-full p-3 border rounded-xl"
        value={value || ""}
        readOnly
      />

      {value && (
        <img
  key={value}
  src={resolveImage(value)}
  alt="preview"
  className="mt-2 h-28 object-contain bg-gray-50 rounded border"
/>

      )}
    </div>
  );
};


    return (
        <div className={`flex bg-gray-100 min-h-screen overflow-x-hidden ${isOpen ? "overflow-hidden" : ""}`}>
            <AdminSidebar isOpen={isOpen} setIsOpen={setIsOpen} />

            <div className="flex-1 min-w-0 lg:ml-64 transition-all duration-300">
                <AdminHeader setIsOpen={setIsOpen} />

                <main className="p-4 sm:p-6 animate-fadeSlide">
       {/* 🚫 Mobile block message */}
<div className="block md:hidden">
  <div className="min-h-[60vh] flex items-center justify-center px-6">
    <div className="bg-white border rounded-2xl p-6 text-center shadow max-w-sm">
      <h2 className="text-lg font-bold text-gray-800 mb-2">
        {lang === "AR"
          ? "هذه الميزة متاحة فقط على أجهزة الكمبيوتر"
          : "This feature is available only on desktop"}
      </h2>
      <p className="text-gray-500 text-sm">
        {lang === "AR"
          ? "يرجى استخدام جهاز لوحي أو كمبيوتر للوصول إلى هذه الصفحة"
          : "Please use a tablet or desktop device to access this page"}
      </p>
    </div>
  </div>
</div>
         
<div className="hidden md:block">
                    <h2 className="text-xl font-bold text-cyan-700 mt-10 mb-4">
  Homepage – Category Cards
</h2>

<div className="grid md:grid-cols-2 gap-6">
  {categoryCards.map((c) => (
    <div key={c.id} className="bg-white p-4 rounded-xl shadow">
      <img src={resolveImage(c.mobile_image)} className="h-40 w-full object-contain bg-gray-50 rounded" />

      <p className="mt-2 font-semibold">{c.title_en}</p>
      <p className="text-sm text-gray-500">{c.title_ar}</p>

      <button
        className="mt-3 text-cyan-600 font-semibold"
        onClick={() => setEditModal({ type: "card", data: { ...c } })}
      >
        Edit
      </button>
    </div>
  ))}
</div>

<h2 className="text-xl font-bold text-cyan-700 mt-12 mb-4">
  Homepage – Category Hero
</h2>

{categoryHero && (
  <div className="bg-white p-4 rounded-xl shadow">
    <img
      src={resolveImage(categoryHero.image_url)}
      className="h-40 w-full object-contain bg-gray-50 rounded"
    />

    <p className="mt-2 font-semibold">{categoryHero.title_en}</p>
    <p className="text-sm text-gray-500">{categoryHero.title_ar}</p>

    <button
      className="mt-3 text-cyan-600 font-semibold"
      onClick={() =>
        setEditModal({ type: "categoryHero", data: { ...categoryHero } })
      }
    >
      Edit
    </button>
  </div>
)}

<h2 className="text-xl font-bold text-cyan-700 mt-12 mb-4">
  Homepage – Featured Categories
</h2>

<div className="grid md:grid-cols-2 gap-6">
  {featuredCategories.map((c) => (
    <div key={c.id} className="bg-white p-4 rounded-xl shadow">
      <img
        src={resolveImage(c.mobile_image)}
        className="h-40 w-full object-contain bg-gray-50 rounded"
      />

      <p className="mt-2 font-semibold">{c.title_en}</p>
      <p className="text-sm text-gray-500">{c.title_ar}</p>

      <button
        className="mt-3 text-cyan-600 font-semibold"
        onClick={() =>
          setEditModal({ type: "featured", data: { ...c } })
        }
      >
        Edit
      </button>
    </div>
  ))}
</div>

<h2 className="text-xl font-bold text-cyan-700 mt-12 mb-4">
  Homepage – Accessories Section
</h2>

{accessoriesSection && (
  <div className="bg-white p-4 rounded-xl shadow">
    <img
      src={resolveImage(accessoriesSection.image_url)}
      className="h-40 w-full object-contain bg-gray-50 rounded"
    />

    <p className="mt-2 font-semibold">{accessoriesSection.title_en}</p>
    <p className="text-sm text-gray-500">{accessoriesSection.title_ar}</p>

    <button
      className="mt-3 text-cyan-600 font-semibold"
      onClick={() =>
        setEditModal({ type: "accessories", data: { ...accessoriesSection } })
      }
    >
      Edit
    </button>
  </div>
)}

<h2 className="text-xl font-bold text-cyan-700 mt-12 mb-4">
  Homepage – Flats Mini Section
</h2>

{flatsMiniSection && (
  <div className="bg-white p-4 rounded-xl shadow">
    <img
      src={resolveImage(flatsMiniSection.image_url)}
      className="h-40 w-full object-contain bg-gray-50 rounded"
    />

    <p className="mt-2 font-semibold">{flatsMiniSection.title_en}</p>
    <p className="text-sm text-gray-500">{flatsMiniSection.title_ar}</p>

    <button
      className="mt-3 text-cyan-600 font-semibold"
      onClick={() =>
        setEditModal({ type: "flatsMini", data: { ...flatsMiniSection } })
      }
    >
      Edit
    </button>
  </div>
)}


<h2 className="text-xl font-bold text-cyan-700 mt-12 mb-4">
  Homepage – Category Carousel
</h2>

<div className="bg-white p-4 rounded-xl shadow">
  <div className="flex gap-4 overflow-x-auto scrollbar-hide">
    {carouselCategories
  .slice()
  .sort((a, b) => a.sort_order - b.sort_order)
  .map((c, index) => (
    <div
      key={c.id}
      draggable
      onDragStart={() => handleDragStart(index)}
      onDragOver={(e) => e.preventDefault()}
      onDrop={() => handleDrop(index)}
      className="
        flex flex-col items-center min-w-[90px]
        cursor-move
        group
      "
    >
      {/* ORDER BADGE */}
      <div className="mb-1 text-xs font-bold text-white bg-cyan-600 rounded-full w-6 h-6 flex items-center justify-center">
        {index + 1}
      </div>

      {/* RING */}
      <div className="p-[2px] rounded-full bg-gradient-to-tr from-pink-500 via-red-500 to-yellow-400 group-hover:scale-105 transition">
        <div className="bg-white p-[2px] rounded-full">
          <img
            src={resolveImage(c.image_url) || "/images/cat-heels.jpg"}
            alt={c.name_en}
            className="w-[70px] h-[70px] object-contain bg-gray-50 rounded-full"
          />
        </div>
      </div>

      {/* NAME */}
      <span className="mt-2 text-xs font-medium text-center truncate max-w-[80px]">
        {c.name_en}
      </span>

      {/* SLUG */}
      <span className="text-[10px] text-gray-400 truncate max-w-[80px]">
        {c.slug}
      </span>
    </div>
))}
  </div>
</div>

<h2 className="text-xl font-bold text-cyan-700 mt-12 mb-4">
  Homepage – Popular Searches Order
</h2>

<div className="bg-white p-4 rounded-xl shadow">
  <div className="flex gap-4 overflow-x-auto scrollbar-hide">
    {orderedPopularItems.map((item, index) => (
      <div
        key={item.key}
        draggable
        onDragStart={() => handlePopularDragStart(index)}
        onDragOver={(e) => e.preventDefault()}
        onDrop={() => handlePopularDrop(index)}
        className="flex flex-col items-center min-w-[90px] cursor-move group"
      >
        {/* ORDER BADGE */}
        <div className="mb-1 text-xs font-bold text-white bg-cyan-600 rounded-full w-6 h-6 flex items-center justify-center">
          {index + 1}
        </div>

        {/* CIRCLE */}
        <div className="w-[70px] h-[70px] rounded-full overflow-hidden bg-gray-100 border flex items-center justify-center">
  {popularImages[item.key] ? (
    <img
      src={resolveImage(popularImages[item.key])}
      alt={item.labelEN}
      className="w-full h-full object-contain bg-gray-50"
    />
  ) : (
    <span className="text-[10px] font-bold text-gray-700 uppercase px-2 text-center">
      {item.key}
    </span>
  )}
</div>


        {/* LABEL */}
        <span className="mt-2 text-xs font-medium text-center truncate max-w-[80px]">
          {lang === "EN" ? item.labelEN : item.labelAR}
        </span>
      </div>
    ))}
  </div>
</div>


<h2 className="text-xl font-bold text-cyan-700 mt-12 mb-4">
  Homepage – Luxury Videos
</h2>

<button
  className="mb-4 px-4 py-2 rounded-xl bg-cyan-600 text-white"
  onClick={() =>
    setEditModal({
      type: "video",
      data: {
        title_en: "",
        title_ar: "",
        video_url: "",
        category_slug: "",
      },
      isNew: true,
    })
  }
>
  + Add Luxury Video
</button>


<div className="grid md:grid-cols-2 gap-6">
  {luxuryVideos.map((v) => (
    <div
      key={v.id}
      className="relative bg-white p-4 rounded-xl shadow"
    >
      {/* DELETE BUTTON */}
      <button
        onClick={async () => {
          setConfirm({
  message: "Are you sure you want to delete this video?",
  onConfirm: async () => {
    await deleteAdminLuxuryVideo(v.id);
    setLuxuryVideos((prev) => prev.filter((x) => x.id !== v.id));
    setConfirm(null);
    showToast("Video deleted successfully");
  },
});


          await deleteAdminLuxuryVideo(v.id);
          setLuxuryVideos((prev) =>
            prev.filter((x) => x.id !== v.id)
          );
        }}
        className="
          absolute top-3 right-3
          w-8 h-8 rounded-full
          bg-red-500 hover:bg-red-600
          text-white
          flex items-center justify-center
        "
        title="Delete video"
      >
        <FaTrash size={12} />
      </button>

      <video
        src={v.video_url}
        muted
        loop
        className="h-40 w-full object-contain bg-black rounded"
      />

      <p className="mt-2 font-semibold">{v.title_en}</p>
      <p className="text-sm text-gray-500">{v.title_ar}</p>

      <button
        className="mt-3 text-cyan-600 font-semibold"
        onClick={() => setEditModal({ type: "video", data: { ...v } })}
      >
        Edit
      </button>
    </div>
  ))}
</div>

              {editModal && (
  <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center px-4">
  <div
    className="
      bg-white
      w-full
      max-w-lg
      rounded-xl
      shadow-xl
      animate-fadeIn
      max-h-[90vh]
      flex
      flex-col
    "
  >

<div className="overflow-y-auto px-6 py-4">

      <h2 className="text-xl font-bold text-cyan-700 mb-4">
  {editModal.type === "card" && "Edit Category Card"}
  {editModal.type === "categoryHero" && "Edit Category Hero"}
  {editModal.type === "video" && "Edit Luxury Video"}
  {editModal.type === "featured" && "Edit Featured Category"}
  {editModal.type === "accessories" && "Edit Accessories Section"}
  {editModal.type === "flatsMini" && "Edit Flats Mini Section"}
</h2>

{editModal.type === "carousel" && (
  <>
    <div className="mb-3 text-sm text-gray-600">
      <div><b>Name:</b> {editModal.data.name_en}</div>
      <div><b>Slug:</b> {editModal.data.slug}</div>
    </div>

    <label className="block text-sm font-medium text-gray-700 mb-1">
  Carousel Image URL
</label>
<ImageUploadField
  label="Carousel Image"
  value={editModal.data.image_url}
  onChange={(url) =>
    setEditModal((prev) => ({
      ...prev,
      data: { ...prev.data, image_url: url },
    }))
  }
/>

  </>
)}


     {editModal.type === "featured" && (
  <>
    
<ImageUploadField
  label="Mobile Image"
  value={editModal.data.mobile_image}
  onChange={(url) =>
    setEditModal((prev) => ({
      ...prev,
      data: { ...prev.data, mobile_image: url },
    }))
  }
/>

<ImageUploadField
  label="Desktop Image"
  value={editModal.data.desktop_image}
  onChange={(url) =>
    setEditModal((prev) => ({
      ...prev,
      data: { ...prev.data, desktop_image: url },
    }))
  }
/>

    <label className="block text-sm font-medium text-gray-700 mb-1">
  Category
</label>
<select
  className="w-full p-3 border rounded-xl mb-3"
      value={editModal.data.category_slug}
      onChange={(e) =>
        setEditModal({
          ...editModal,
          data: {
            ...editModal.data,
            category_slug: e.target.value,
          },
        })
      }
    >
      <option value="">Select Category</option>
      {categories.map((c) => (
        <option key={c.id} value={c.slug}>
          {c.name_en}
        </option>
      ))}
    </select>
  </>
)}


      {/* TITLE EN */}
      <label className="block text-sm font-medium text-gray-700 mb-1">
  Title (EN)
</label>
<input
  className="w-full p-3 border rounded-xl mb-3"
  placeholder="Title (EN)"
        value={editModal.data.title_en}
        onChange={(e) =>
          setEditModal({
            ...editModal,
            data: { ...editModal.data, title_en: e.target.value },
          })
        }
      />

      {/* TITLE AR */}
      <label className="block text-sm font-medium text-gray-700 mb-1">
  Title (AR)
</label>
<input
  className="w-full p-3 border rounded-xl mb-3"
  placeholder="Title (AR)"
        value={editModal.data.title_ar}
        onChange={(e) =>
          setEditModal({
            ...editModal,
            data: { ...editModal.data, title_ar: e.target.value },
          })
        }
      />

{/* ================= ACCESSORIES SECTION ================= */}
{editModal.type === "accessories" && (
  <>
    
    <ImageUploadField
  label="Accessories Image"
  value={editModal.data.image_url}
  onChange={(url) =>
    setEditModal((prev) => ({
      ...prev,
      data: { ...prev.data, image_url: url },
    }))
  }
/>


    <label className="block text-sm font-medium text-gray-700 mb-1">
      Link Target Category
    </label>
    <select
      className="w-full p-3 border rounded-xl mb-3"
      value={editModal.data.link_target || ""}
      onChange={(e) =>
        setEditModal({
          ...editModal,
          data: { ...editModal.data, link_target: e.target.value },
        })
      }
    >
      <option value="">Select Category</option>
      {categories.map((c) => (
        <option key={c.id} value={c.slug}>
          {c.name_en} ({c.slug})
        </option>
      ))}
    </select>
  </>
)}

{editModal.type === "flatsMini" && (
  <>
    
    <ImageUploadField
  label="Flats Mini Image"
  value={editModal.data.image_url}
  onChange={(url) =>
    setEditModal((prev) => ({
      ...prev,
      data: { ...prev.data, image_url: url },
    }))
  }
/>


    <label className="block text-sm font-medium text-gray-700 mb-1">
      Link Target Category
    </label>
    <select
      className="w-full p-3 border rounded-xl mb-3"
      value={editModal.data.link_target || ""}
      onChange={(e) =>
        setEditModal({
          ...editModal,
          data: { ...editModal.data, link_target: e.target.value },
        })
      }
    >
      <option value="">Select Category</option>
      {categories.map((c) => (
        <option key={c.id} value={c.slug}>
          {c.name_en} ({c.slug})
        </option>
      ))}
    </select>
  </>
)}



      {/* ================= CATEGORY CARD ================= */}
      {editModal.type === "card" && (
        <>
        
<ImageUploadField
  label="Mobile Image"
  value={editModal.data.mobile_image}
  onChange={(url) =>
    setEditModal((prev) => ({
      ...prev,
      data: { ...prev.data, mobile_image: url },
    }))
  }
/>


<ImageUploadField
  label="Desktop Image"
  value={editModal.data.desktop_image}
  onChange={(url) =>
    setEditModal((prev) => ({
      ...prev,
      data: { ...prev.data, desktop_image: url },
    }))
  }
/>

        </>
      )}

      {editModal?.type === "categoryHero" && (
  <>
    <label className="block text-sm font-medium text-gray-700 mb-1">
  Subtitle (EN)
</label>
<input
  className="w-full p-3 border rounded-xl mb-3"
  placeholder="Subtitle (EN)"
      value={editModal.data.subtitle_en}
      onChange={(e) =>
        setEditModal({
          ...editModal,
          data: { ...editModal.data, subtitle_en: e.target.value },
        })
      }
    />

    <label className="block text-sm font-medium text-gray-700 mb-1">
  Subtitle (AR)
</label>
<input
  className="w-full p-3 border rounded-xl mb-3"
  placeholder="Subtitle (AR)"
      value={editModal.data.subtitle_ar}
      onChange={(e) =>
        setEditModal({
          ...editModal,
          data: { ...editModal.data, subtitle_ar: e.target.value },
        })
      }
    />

    
<ImageUploadField
  label="Hero Image"
  value={editModal.data.image_url}
  onChange={(url) =>
    setEditModal((prev) => ({
      ...prev,
      data: { ...prev.data, image_url: url },
    }))
  }
/>


    <label className="block text-sm font-medium text-gray-700 mb-1">
  Link Target Category
</label>
<select
  className="w-full p-3 border rounded-xl"
      value={editModal.data.link_target}
      onChange={(e) =>
        setEditModal({
          ...editModal,
          data: { ...editModal.data, link_target: e.target.value },
        })
      }
    >
      <option value="">Select Category</option>
      {categories.map((c) => (
        <option key={c.id} value={c.slug}>
          {c.name_en} ({c.slug})
        </option>
      ))}
    </select>
  </>
)}


      {/* ================= LUXURY VIDEO ================= */}
      {editModal.type === "video" && (
        <>
        <label className="block text-sm font-medium text-gray-700 mb-1">
  Upload Video 
</label>

<input
  type="file"
  accept="video/*"
  className="w-full p-2 border rounded-xl mb-3"
  onChange={(e) => setVideoFile(e.target.files[0])}
/>

<select
  className="w-full p-3 border rounded-xl"
            value={editModal.data.category_slug || ""}
            onChange={(e) =>
              setEditModal({
                ...editModal,
                data: {
                  ...editModal.data,
                  category_slug: e.target.value,
                },
              })
            }
          >
            <option value="">Select Category</option>
            {categories.map((c) => (
              <option key={c.id} value={c.slug}>
                {c.name_en} ({c.slug})
              </option>
            ))}
          </select>
        </>
      )}

      {/* ACTIONS */}
      <div className="flex justify-end gap-3 mt-5">
        <button
          className="px-4 py-2 rounded-xl border"
          onClick={() => setEditModal(null)}
        >
          Cancel
        </button>

        <button
          className="px-4 py-2 rounded-xl bg-cyan-600 text-white"
          onClick={async () => {
            if (editModal.type === "carousel") {
  await updateAdminCategoryCarouselImage(editModal.data.id, {
    image_url: editModal.data.image_url,
  });

  setCarouselCategories((prev) =>
    prev.map((c) =>
      c.id === editModal.data.id ? { ...c, image_url: editModal.data.image_url } : c
    )
  );

  setEditModal(null);
  return;
}
if (editModal.type === "flatsMini") {
  await updateAdminFlatsMiniSection(editModal.data);
  setFlatsMiniSection((prev) => ({
  ...prev,
  ...editModal.data,
}));
}

if (editModal.type === "accessories") {
  await updateAdminAccessoriesSection(editModal.data);
  setAccessoriesSection((prev) => ({
  ...prev,
  ...editModal.data,
}));
}


            if (editModal.type === "featured") {
  await updateAdminFeaturedCategory(
    editModal.data.id,
    editModal.data
  );

  setFeaturedCategories((prev) =>
  prev.map((f) =>
    f.id === editModal.data.id
      ? { ...f, ...editModal.data }
      : f
  )
);
}


            if (editModal.type === "categoryHero") {
  await updateAdminCategoryHero(editModal.data);
  setCategoryHero((prev) => ({
  ...prev,
  ...editModal.data,
}));
}

           if (editModal.type === "card") {
  await updateAdminCategoryCard(
    editModal.data.id,
    editModal.data
  );

  setCategoryCards((prev) =>
  prev.map((c) =>
    c.id === editModal.data.id
      ? { ...c, ...editModal.data }
      : c
  )
);
}

if (editModal.type === "video") {
  let videoUrl = editModal.data.video_url;

  if (videoFile) {
  const json = await uploadAdminLuxuryVideo(videoFile);
  videoUrl = json.video_url;

  // ✅ AUTO-FILL input
  setEditModal((prev) => ({
    ...prev,
    data: {
      ...prev.data,
      video_url: json.video_url,
    },
  }));
}

  const payload = {
    ...editModal.data,
    video_url: videoUrl,
  };

  if (editModal.isNew) {
    await createAdminLuxuryVideo(payload);
    setLuxuryVideos(await getAdminLuxuryVideos());
  } else {
    await updateAdminLuxuryVideo(editModal.data.id, payload);
    setLuxuryVideos((prev) =>
      prev.map((v) =>
        v.id === editModal.data.id ? payload : v
      )
    );
  }

  setVideoFile(null);
}


            setEditModal(null);
          }}
        >
          Save
        </button>
       </div> 
      </div>
    </div>
  </div>
)}

{confirm && (
  <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center">
    <div className="bg-white rounded-xl p-6 w-full max-w-sm shadow-xl">
      <p className="text-gray-800 text-center mb-6">
        {confirm.message}
      </p>

      <div className="flex justify-center gap-4">
        <button
          className="px-4 py-2 rounded-xl border"
          onClick={() => setConfirm(null)}
        >
          Cancel
        </button>

        <button
          className="px-4 py-2 rounded-xl bg-red-600 text-white"
          onClick={confirm.onConfirm}
        >
          Confirm
        </button>
      </div>
    </div>
  </div>
)}

{toast && (
  <div className="fixed bottom-6 right-6 z-50">
    <div className="bg-cyan-600 text-white px-5 py-3 rounded-xl shadow-lg animate-fadeIn">
      {toast}
    </div>
  </div>
)}


</div>
                </main>
            </div>
        </div>
    );
}

export default AdminSettings;
